import DescriptionCard from './DescriptionCard';

export { DescriptionCard };
export default DescriptionCard;
